import 'moment/locale/es';
import * as moment from 'moment';

import React, { Component } from 'react';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Pagination from 'react-bootstrap/Pagination';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { ReactSVG } from 'react-svg';

import styles from './Commerce.module.css';

import headerImage from './../images/modules/commerce.jpg';

import historyIcon from './../icons/ic_history.svg';
import documentsIcon from './../icons/ic_documents.svg';
import filterIcon from './../icons/ic_filter.svg';
import resolutionIcon from './../icons/ic_resolution.svg';
import uploadIcon from './../icons/ic_upload.svg';
import downloadIcon from './../icons/ic_download.svg';

import { CPLBanner } from '../../../components/Banner';
import { LanguageContext } from '../../../i18n/LanguageContext';

import { CommerceService } from '../../../services/ApiService';

export default class CommerceModule extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            commerces: [],
            hideEditor: true,
            modalType: '',
            CommerceID: null,
            showModal: false,
            history: [],
            documents: [],
            commerce: null,
            filter: {
                state: null,
                startDate: moment().startOf('month').format('YYYY/MM/DD'),
                endDate: moment().endOf('month').format('YYYY/MM/DD'),
                search: ''
            },
            search: ''
        }
    }

    onSearch = (search) => {
        const filter = {
            search: search
        }

        this.setState({ filter: {...this.state.filter, ...filter} });
    }

    onFilterChange = (filter) => {
        delete filter.search;
        this.setState({ filter: {...this.state.filter, ...filter} })
    };

    onCloseModal = () => {
        this.setState({
            showModal: false,
            modalType: '',
            CommerceID: null,
            history: [],
            documents: []
        });
    }

    onUpdateStatus = async (id, status, resolution, justification) => {
        try {
            let commerce = await CommerceService.updateStatus(id, status, resolution, justification);
            const commerces = this.getUpdatedStatusCommerce(this.state.commerces, id, status);
            this.setState({ hideEditor: true, commerce, commerces });
        } catch (e) {
            console.error(e);
        }
    }

    onHistoryClick = async (commerce) => {
        const id = commerce.CommerceRequestID;
        let history = await CommerceService.getHistory(id);
        this.setState({ showModal: true, modalType: 'history', CommerceID: id, commerce: commerce, history: history });
    }

    onCommerceReject = async (commerce, resolution) => {
        const id = commerce.CommerceRequestID;
        this.setState({ showModal: true, modalType: 'justification', CommerceID: id, commerce: commerce, resolution: resolution });
    }

    onSaveJustification = async (id, resolution, justification) => {
        await this.onUpdateStatus(id, 'rejected', resolution, justification);
        this.onCloseModal();
    }

    onDocumentsClick = async (commerce) => {
        const id = commerce.CommerceRequestID;
        let documents = await CommerceService.getDocuments(id);
        this.setState({ showModal: true, modalType: 'documents', CommerceID: id, documents: documents, commerce: commerce });
    }

    filterCommerces(search, commerce, properties) {
        // eslint-disable-next-line no-unused-vars
        for (let prop of properties) {
            if (RegExp(`(.)*${search}(.)*`, 'i').test(commerce[prop])) {
                return true;
            }
        }
        return false;
    }

    getUpdatedStatusCommerce(commerces, id, status) {
        return commerces.map(commerce => {
            if (commerce.id === id) {
                commerce.status = status;
            }

            let statusValue = '';
            switch (commerce.status) {
                case 'pending':
                    statusValue = this.context['PENDING'];
                    break;
                case 'viewed':
                    statusValue = this.context['VIEWED'];
                    break;
                case 'acknowledge':
                    statusValue = this.context['ACKNOWLEDGE'];
                    break;
                case 'rejected':
                case 'cancelled':
                    statusValue = this.context['REJECTED'];
                    break;
                default: statusValue = '';
                    break;
            }

            commerce.statusValue = statusValue;
            return commerce;
        })
    }

    onCommerceClicked = (commerce) => {
        const id = commerce.id;
        CommerceService.getByID(id)
            .then(commerce => {
                const commerces = this.getUpdatedStatusCommerce(this.state.commerces, id, commerce.status);
                this.setState({ hideEditor: false, commerce, commerces });
            })
            .catch(e => console.error(e));
    }

    onResolutionClick = (commerce) => {
        CommerceService.downloadResolution(commerce.CommerceRequestID, this.context['ERROR_RESOLUTION_NOT_AVAILABLE']);
    }

    async componentDidMount() {
        await this.getCommerces();
    }

    async getCommerces() {
        let commerces = await CommerceService.getAllCommerces();
        commerces = commerces.map(commerce => {
            let status = '';
            switch (commerce.status) {
                case 'pending':
                    status = this.context['PENDING'];
                    break;
                case 'viewed':
                    status = this.context['VIEWED'];
                    break;
                case 'acknowledge':
                    status = this.context['ACKNOWLEDGE'];
                    break;
                case 'rejected':
                case 'cancelled':
                    status = this.context['REJECTED'];
                    break;
                default: status = '';
                    break;
            }

            commerce.statusValue = status;
            return commerce;
        }).map(commerce => {
            return {
                id: commerce.CommerceRequestID,
                businessName: commerce.businessName,
                status: commerce.status,
                statusValue: commerce.statusValue,
                createdAt: moment(commerce.createdAt).format('YYYY-MM-DD')
            };
        })
        this.setState({ commerces: commerces });
    }

    render() {
        const filter = this.state.filter;
        let commerces = this.state.commerces;
        if(!!filter.startDate && !!filter.endDate) {
            commerces = commerces.filter(commerce => moment(new Date(commerce.createdAt)).isSameOrAfter(filter.startDate) && moment(new Date(commerce.createdAt)).isSameOrBefore(filter.endDate));
        }

        if(!!filter.state) {
            commerces = commerces.filter(commerce => commerce.status === filter.state);
        }

        if (!!filter.search) {
            commerces = commerces
                .filter(commerce => this.filterCommerces(filter.search, commerce, [
                    'businessName'
                ]));
        }

        let editor = null;
        if (!this.state.hideEditor) {
            editor = <Editor
                onUpdateStatus={this.onUpdateStatus}
                commerce={this.state.commerce}
                onResolutionClick={this.onResolutionClick}
                onDocumentsClick={this.onDocumentsClick}
                onCommerceReject={this.onCommerceReject}
                onHistoryClick={this.onHistoryClick} />
        }

        let modal = null;
        if (!!this.state.showModal) {
            switch (this.state.modalType) {
                case 'history':
                    modal = <HistoryModal
                        CommerceID={this.state.CommerceID}
                        history={this.state.history}
                        commerce={this.state.commerce}
                        closeModal={this.onCloseModal}
                        showModal={this.state.showModal} />
                    break;
                case 'documents':
                    modal = <DocumentsModal
                        CommerceID={this.state.CommerceID}
                        documents={this.state.documents}
                        commerce={this.state.commerce}
                        closeModal={this.onCloseModal}
                        showModal={this.state.showModal} />
                    break;
                case 'justification':
                    modal = <JustificationModal
                        CommerceID={this.state.CommerceID}
                        closeModal={this.onCloseModal}
                        resolution={this.state.resolution}
                        onSave={this.onSaveJustification}
                        showModal={this.state.showModal} />
                        break;
                default:
                    modal = null;
            }
        }
        
        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['COMMERCE_ADMIN_MODULE_NAME']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-7 col-md-7">
                    <CommerceAdmin
                        onFilterChange={this.onFilterChange}
                        commerces={commerces}
                        filter={this.state.filter}
                        onCommerceClicked={this.onCommerceClicked}
                        onSearch={this.onSearch}
                    />
                </div>
                <div className="col-lg-5 col-md-5">
                    {editor}
                </div>
            </div>
            {modal}
        </div>
    }
}

class CommerceAdmin extends Component {

    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: '',
            displayFilterBar: false,
            filter: this.props.filter
        };
    }

    onSearchListener = (event) => {
        this.props.onSearch(event.target.value);
        this.setState({ search: event.target.value });
    }

    toggleFilterBar = () => {
        this.setState({displayFilterBar: !this.state.displayFilterBar});
    }

    getStatusValue(status) {
        switch (status) {
            case 'pending':
                return this.context['PENDING'];
            case 'viewed':
                return this.context['VIEWED'];
            case 'acknowledge':
                return this.context['ACKNOWLEDGE'];
            case 'rejected':
            case 'cancelled':
                return this.context['REJECTED'];
            default:
                return '';
        }
    }

    onFilterChange = (filter) => this.props.onFilterChange(filter);

    render() {
        let commerces = this.props.commerces.map(commerce => {
            commerce.statusValue = this.getStatusValue(commerce.status);
            return commerce;
        });

        let filterBar = null;
        if(this.state.displayFilterBar) {
            filterBar = <FilterBar 
                filter={this.props.filter}
                onFilterChange={this.onFilterChange} />;
        }

        return <div>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                            <div className='col-md-12'>
                                {this.context['COMMERCES']}
                                <span className="float-right">
                                    <OverlayTrigger
                                        key="top"
                                        placement="top"
                                        overlay={<Tooltip>{this.context['FILTER']}</Tooltip>}>
                                        <div className={styles['panel-button']} onClick={this.toggleFilterBar}>
                                            <ReactSVG
                                                src={filterIcon}
                                                className={styles['filter-button']} />
                                        </div>
                                    </OverlayTrigger>
                                </span>
                                <span className="float-right">
                                    <div className={styles['search-form']}>
                                        <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                                    </div>
                                </span>
                            </div>
                    </div>
                    {filterBar}
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['COMMERCE']}</th>
                                <th>{this.context['DATE']}</th>
                                <th>{this.context['STATE']}</th>
                            </tr>
                        </thead>
                        <CommerceList
                            onCommerceClicked={this.props.onCommerceClicked}
                            commerces={commerces} />
                    </table>
                </div>
            </div>
        </div>
    }
}

class FilterBar extends Component {

    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);

        this.commerceStates = [
            'PENDING',
            'VIEWED',
            'ACKNOWLEDGE',
            'REJECTED'
        ]

        this.state = {
            search: '',
            filter: this.props.filter,
            errorComponent: null
        };
    }

    onStartDateChange = (e) => {
        if(!!e.target.value) {
            const endDate = this.state.filter.endDate;
            const date = moment(e.target.value).format('YYYY/MM/DD');

            if(moment(date).isAfter(endDate)) {
                this.setErrorComponent('ERROR_START_DATE_BIGGER_THAN_END_DATE');
            } else {
                const filter = {
                    startDate: date
                };
                
                this.props.onFilterChange({...this.state.filter, ...filter});
                this.setState({filter: {...this.state.filter, ...filter}});
                this.setErrorComponent();
            }
            
        }
    }

    onEndDateChange = (e) => {
        if(!!e.target.value) {
            const startDate = this.state.filter.startDate;
            const date = moment(e.target.value).format('YYYY/MM/DD');
            
            if(moment(date).isBefore(startDate)) {
                this.setErrorComponent('ERROR_END_DATE_SMALLER_THAN_START_DATE');
            } else {
                const filter = {
                    endDate: date
                };
                
                this.props.onFilterChange({...this.state.filter, ...filter});
                this.setState({filter: {...this.state.filter, ...filter}});
                this.setErrorComponent();
            }
        }
    }

    setErrorComponent = (errorMessage) => {
        const timeoutToDissolve = 3000;
        if(!errorMessage) {
            this.setState({errorComponent: null});
        } else {
            this.setState({errorComponent: <div className={styles['filter-bar-date-error']}>
                <p>{this.context[errorMessage]}</p>
            </div>});
            setTimeout(() => this.setState({errorComponent: null}), timeoutToDissolve);
        }
    }

    getValueFromIndex(array, value) {
        if(value === null) return null;
        const index = array.indexOf(value.toUpperCase());
        if(index === -1) return null;
        return index;
    }

    onStateChange = (index) => {
        const filter = {
            state: null
        };
        
        if(index >= 0) {
            filter.state = this.commerceStates[index].toLowerCase();
        }

        this.props.onFilterChange({...this.state.filter, ...filter});
        this.setState({filter: {...this.state.filter, ...filter}});
    }

    render() {
        const filter = this.props.filter;

        const states = this.commerceStates.map(state => this.context[state])
        const selectedState = this.getValueFromIndex(this.commerceStates, filter.state);

        let stateTitle = 'Seleccione un estatus';
        if(this.context['LANG'] === 'en') {
            stateTitle = 'Select an state';
        }

        const startDate = moment(filter.startDate).format('YYYY-MM-DD');
        const endDate = moment(filter.endDate).format('YYYY-MM-DD');
        return <div className='row'>
            <div className={`col-md-12 ${styles['filter-bar']}`}>
                <DynamicSelect 
                    data={states} 
                    title={stateTitle}
                    selection={selectedState}
                    onSelectChange={this.onStateChange}/>
                <div>
                    <div className={styles['filter-bar-input-container']}>
                        <div className={styles['filter-bar-input-container-label']}>
                            <small>{this.context['START_DATE']}</small>
                        </div>
                        <div>
                            <input value={startDate} type="date" onChange={this.onStartDateChange} required/>
                        </div>
                    </div>
                    <div className={styles['filter-bar-input-container']}>
                        <div>
                            <small>{this.context['END_DATE']}</small>
                        </div>
                        <div>
                            <input value={endDate} type="date" onChange={this.onEndDateChange} required/>    
                        </div>
                    </div>
                    {this.state.errorComponent}
                </div>
            </div>
        </div>
    }
}

class DynamicSelect extends Component {

    static contextType = LanguageContext

    constructor(props) {
        super(props);
        let selection;
        if(this.props.selection !== null) {
            selection = this.props.selection + 1;
        } else {
            selection = 0
        }

        this.state = {
            selection: selection
        }
    }

    handleChange = (event) => {
        let selectedValue = parseInt(event.target.value);
        const dataIndex = selectedValue -1;
        this.props.onSelectChange(dataIndex);
        this.setState({selection: selectedValue});
    }

    render() {
        const data = [...[this.props.title], ...this.props.data];
        const options = data.map((option, index) => <option key={index} value={index}> {option} </option>);

        return <div className={styles['filter-select']}> 
            <select onChange={this.handleChange} value={this.state.selection}>
                {options}
            </select>
        </div>
    }

}

const CommerceList = function (props) {
    return <tbody>
        {props.commerces.map((commerce, index) => {
            commerce.index = index;

            return <ComerceListItem
                key={index}
                index={index}
                commerce={commerce}
                onCommerceClicked={props.onCommerceClicked}
            />
        })}
    </tbody>
}

const ComerceListItem = function (props) {
    const commerce = props.commerce;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onCommerceClicked(commerce)}>
        <td>{commerce.businessName}</td>
        <td>{commerce.createdAt}</td>
        <td className={styles[`commerce-status-${commerce.status}`]}>{commerce.statusValue}</td>
    </tr>
}

class Editor extends Component {

    static contextType = LanguageContext;
    constructor(props, context) {
        super(props, context);
        this.state = {
            missingFile: false,
            uploadedFileName: '',
            file: null
        };
    }

    getStatusValue(status) {
        switch (status) {
            case 'pending':
                return this.context['PENDING'];
            case 'viewed':
                return this.context['VIEWED'];
            case 'acknowledge':
                return this.context['ACKNOWLEDGE'];
            case 'rejected':
            case 'cancelled':
                return this.context['REJECTED'];
            default:
                return '';
        }
    }

    onUploadFile = (e) => {
        const file = e.target.files[0];
        if (!!file) {
            if(file.type !== 'application/pdf') {
                alert(this.context['ERROR_ONLY_PDF'])
                return;
            } 

            this.setState({ file: file,  uploadedFileName: file['name'], missingFile: false});
        }
    }

    formatDate = (date) => {
        const words = date.split(' ');
        const response = [];
        for (let word of words) {
            if (word.length <= 2) {
                response.push(word);
            } else {
                response.push(word[0].toUpperCase() + word.slice(1));
            }
        }
        return response.join(' ');
    }

    render() {
        const commerce = this.props.commerce;
        const id = commerce.CommerceRequestID;

        const labelClassName = `col-md-4`;
        const labelValueClassName = `col-md-8`;

        let operationsKeyComponent = null;

        if (!!commerce.isInZLC) {
            operationsKeyComponent = <div className={`row ${styles['editor-rows']}`}>
                <div className={labelClassName}>
                    <p className={styles['editor-form-control-label']}>{this.context['COMMERCE_OPERATIONS_KEY']}</p>
                </div>
                <div className={labelValueClassName}>
                    <input className={styles['editor-form-control']} type="text" value={commerce.operationsKey} readOnly />
                </div>
            </div>
        }

        let resolutionComponent;
        if (commerce.status === 'rejected' || commerce.status === 'acknowledge') {
            resolutionComponent = <span className="float-right">
                <OverlayTrigger
                    key="top"
                    placement="top"
                    overlay={<Tooltip>{this.context['COMMERCE_RESOLUTION']}</Tooltip>}>
                    <div className={styles['panel-button']} onClick={() => this.props.onResolutionClick(commerce)}>
                        <ReactSVG
                            src={resolutionIcon}
                            className={styles['resolution-button']} />
                    </div>
                </OverlayTrigger>
            </span>
        }

        let uploadResolutionComponent = null;
        if (commerce.status === 'viewed') {
            let uploadFileLabel = this.context['DOCUMENTS_SELECT_FILE_DEFAULT'];
            if(!!this.state.uploadedFileName) {
                uploadFileLabel = this.state.uploadedFileName;
            }
            const errorColorStyle = {
                color: '#f00'
            }

            let resolutionErrorComponent = null;
            if(this.state.missingFile) {
                resolutionErrorComponent = <small style={errorColorStyle}>
                    {this.context['ERROR_RESOLUTION_REQUIRED']}
                </small>
            }
            uploadResolutionComponent = <div className={`row ${styles['editor-rows']}`}>
                <div className={labelClassName}>
                    <p className={styles['editor-form-control-label']}>{this.context['COMMERCE_RESOLUTION']} <b style={errorColorStyle}>*</b>
                    </p>
                </div>
                <div className={labelValueClassName}>
                    <div className={styles['resolution-input-container']}>
                        <input type="file" name="document_file" id="document_file" className={this.state.missingFile ? styles['resolution-file-error'] : styles['resolution-file']}  onChange={this.onUploadFile} />
                        <label htmlFor="document_file"> 
                            <ReactSVG src={uploadIcon} className={styles['upload-button']} /> 
                            {uploadFileLabel}
                        </label>
                        {resolutionErrorComponent}
                    </div>
                </div>
            </div>
        }

        let updateStatusComponent = null;
        let justificationComponent = null;
        if (commerce.status === 'viewed') {
            updateStatusComponent = <div className="card-footer">
                <span className="float-right">
                    <Button variant="success" onClick={() => {
                        if(!this.state.file) {
                            this.setState({missingFile: true});
                            return
                        }
                        this.setState({
                            missingFile: false,
                            uploadedFileName: '',
                            file: null
                        });
                        this.props.onUpdateStatus(id, 'acknowledge', this.state.file);
                    }}>
                        {this.context['ACKNOWLEDGE']}
                    </Button>
                </span>
                <span className="float-right">
                    <Button variant="danger" onClick={() => {
                        if(!this.state.file) {
                            this.setState({missingFile: true});
                            return
                        }

                        this.setState({
                            missingFile: false,
                            uploadedFileName: '',
                            file: null
                        });
                        this.props.onCommerceReject(commerce, this.state.file)
                    }}>
                        {this.context['REJECTED']}
                    </Button>
                </span>
            </div>
        } else if(commerce.status === 'rejected' && commerce.rejectJustification) {
            justificationComponent = <div className={`row ${styles['editor-rows']}`}>
                <div className={labelClassName}>
                    <p className={styles['editor-form-control-label']}>{this.context['COMMERCE_REJECTED_JUSTIFICATION']}</p>
                </div>
                <div className={labelValueClassName}>
                    <input className={styles['editor-form-control']} type="text" value={commerce.rejectJustification} readOnly />
                </div>
            </div>
        }

        let resolutionDownloadDateComponent = null;
        if(!!commerce.resolutionDownloadDate) {
            moment.locale(this.context['LANG']);
            const dateValue = this.formatDate(moment(new Date(commerce.resolutionDownloadDate)).format('dddd, MMMM Do YYYY, h:mm:ss a'));
            resolutionDownloadDateComponent = <div className={`row ${styles['editor-rows']}`}>
                <div className={labelClassName}>
                    <p className={styles['editor-form-control-label']}>{this.context['COMMERCE_RESOLUTION']}</p>
                </div>
                <div className={labelValueClassName}>
                    <input className={styles['editor-form-control']} type="text" value={dateValue} readOnly />
                </div>
            </div>
        }

        return <div className="card">
            <div className="card-header">
                {commerce.businessName}
                {resolutionComponent}
                <span className="float-right">
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={<Tooltip>{this.context['COMMERCE_HISTORY']}</Tooltip>}>
                        <div className={styles['panel-button']} onClick={() => this.props.onHistoryClick(commerce)}>
                            <ReactSVG
                                src={historyIcon}
                                className={styles['history-button']} />
                        </div>
                    </OverlayTrigger>
                </span>
                <span className="float-right">
                    <OverlayTrigger
                        key="top"
                        placement="top"
                        overlay={<Tooltip>{this.context['COMMERCE_DOCUMENTS']}</Tooltip>}>
                        <div className={styles['panel-button']} onClick={() => this.props.onDocumentsClick(commerce)}>
                            <ReactSVG
                                src={documentsIcon}
                                className={styles['documents-button']} />
                        </div>
                    </OverlayTrigger>
                </span>
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['NAME']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.businessName} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['ADDRESS']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.address} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['EMAIL']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.email} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['PHONE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.phone || ''} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['RUC']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.ruc || ''} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['LEGAL_REPRESENTATIVE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.legalRepresentative} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['NATIONALITY']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.nationality} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['COMMERCE_REGISTER_TYPE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.registerType} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['IS_IN_ZLC']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['form-check-input']} type="checkbox" checked={commerce.isInZLC} readOnly />
                    </div>
                </div>
                {operationsKeyComponent}
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['ACTIVITY_DESCRIPTION']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.activityDescription} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['PRODUCTS_DESCRIPTION']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.productsDescription} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['IMPORT_COUNTRIES']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.importCountries} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['EMPLOYEES']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.employees} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['OBSERVATIONS']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={commerce.observations} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['STATUS']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={this.getStatusValue(commerce.status)} readOnly />
                    </div>
                </div>
                {resolutionDownloadDateComponent}
                {uploadResolutionComponent}
                {justificationComponent}
            </div>
            {updateStatusComponent}
        </div>
    }
}

class HistoryModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.history = this.props.history;

        const itemsPerPage = 10;
        
        let selectedPage = 0;
        let totalOfPages = 0;
        const totalOfItems = this.history.length;
        let history = [];

        if(totalOfItems > itemsPerPage) {
            if(totalOfItems % itemsPerPage === 0) {
                totalOfPages = totalOfItems / itemsPerPage;
            } else {
                totalOfPages = Math.floor(totalOfItems / itemsPerPage) + 1;
            }
            history = this.history.slice(0, (itemsPerPage - 1) + 1);
        } else {
            history = this.history;
        }
        
        this.state = {
            itemsPerPage: itemsPerPage,
            selectedPage: selectedPage,
            totalOfPages: totalOfPages,
            history: history
        }
    }

    getStatusValue(status) {
        switch (status) {
            case 'pending':
                return this.context['PENDING'];
            case 'viewed':
                return this.context['VIEWED'];
            case 'acknowledge':
                return this.context['ACKNOWLEDGE'];
            case 'rejected':
            case 'cancelled':
                return this.context['REJECTED'];
            default:
                return '';
        }
    }

    onPageClick = (page) => {
        const lowerIndex = page * this.state.itemsPerPage;
        const higerIndex = lowerIndex + (this.state.itemsPerPage -1);

        this.setState({selectedPage: page, history: this.history.slice(lowerIndex, higerIndex + 1)})
    }

    getPaginationComponent = () => {
        if(!this.state.totalOfPages) return null;

        let items = [];
        for (let page = 0; page < this.state.totalOfPages; page++) {
            items.push(
              <Pagination.Item key={page} active={page === this.state.selectedPage} onClick={() => this.onPageClick(page)}>
                {page + 1}
              </Pagination.Item>
            );
        }

        return <div className={styles['pagination']}>
            <div>
                <Pagination className={styles['pagination']}>{items}</Pagination>
            </div>
        </div>
    }

    render() {
        return <Modal show={this.props.showModal} onHide={() => this.props.closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{this.context['COMMERCE_HISTORY']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table className="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th>{this.context['STATUS']}</th>
                            <th>{this.context['DATE']}</th>
                            <th>{this.context['HOUR']}</th>
                            <th>{this.context['COMMERCE_CREATED_BY']}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.history.map((history, index) => <tr key={index}>
                            <td className={styles[`commerce-status-${history.status}`]}>{this.getStatusValue(history.status)}</td>
                            <td>{moment(history.createdAt).format('YYYY-MM-DD')}</td>
                            <td>{moment(history.createdAt).format('hh:mm A')}</td>
                            <td>{history.createdByName}</td>
                        </tr>)}
                    </tbody>
                </table>
                {this.getPaginationComponent()}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.closeModal}>
                    {this.context['CLOSE']}
                </Button>
            </Modal.Footer>
        </Modal>
    }
}

class DocumentsModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.downloadDocument = this.downloadDocument.bind(this);
    }

    fileDownload(data, filename) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }

    async downloadDocument(document) {
        const CommerceID = document.CommerceRequestID;
        const DocumentID = document.CommerceRequestDocumentID;

        const bussinesName = this.props.commerce.businessName;

        let data = await CommerceService.downloadDocument(CommerceID, DocumentID);
        this.fileDownload(data, `${bussinesName}-${document.documentType}.pdf`);
    }

    render() {
        return <Modal show={this.props.showModal} onHide={() => this.props.closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{this.context['COMMERCE_DOCUMENTS']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table className="table table-borderless table-hover">
                    <tbody>
                        {this.props.documents.map((document, index) => <tr key={index}>
                            <td>{this.context[document.documentType.toUpperCase()]}</td>
                            <td>
                                <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={<Tooltip>{this.context['DOWNLOAD']}</Tooltip>}>
                                    <div className={styles['panel-button']} onClick={() => this.downloadDocument(document)}>
                                        <ReactSVG
                                            src={downloadIcon}
                                            className={styles['download-document-button']} />
                                    </div>
                                </OverlayTrigger>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.closeModal}>
                    {this.context['CLOSE']}
                </Button>
            </Modal.Footer>
        </Modal>
    }
}

class JustificationModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);

        this.state = {
            justification: ''
        };
    }

    onSave = () => this.props.onSave(this.props.CommerceID, this.props.resolution, this.state.justification);

    onJustificationChange = (evt) => {
        evt.preventDefault();
        this.setState({justification: evt.target.value});
    }

    render() {
        let saveButtonComponent = null;
        if(!!this.state.justification) {
            saveButtonComponent = <Button variant="success" onClick={this.onSave}>
                {this.context['SAVE']}
            </Button>
        } else {
            saveButtonComponent = <Button variant="success" onClick={this.onSave} disabled>
                {this.context['SAVE']}
            </Button>
        }

        return <Modal show={this.props.showModal} onHide={() => this.props.closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{this.context['COMMERCE_REJECTED_JUSTIFICATION']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Control type="text" size="lg" value={this.state.justification} onChange={this.onJustificationChange}/>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                {saveButtonComponent}
            </Modal.Footer>
        </Modal>
    }
}